import api, { apiSuccessOutput } from '@/shared/config/api.js';

// Create Tenant
export const createTenant = async (name, description) => {
  return apiSuccessOutput(
    await api.post('/tenant/v1', {
      name,
      description,
    }),
  );
};

// Update Tenant
export const updateTenant = async (tenant_id, name, description) => {
  return apiSuccessOutput(
    await api.put(`/tenant/v1/${tenant_id}`, {
      name,
      description,
    }),
  );
};

// Delete Tenant
export const deleteTenant = async (tenant_id) => {
  return apiSuccessOutput(await api.delete(`/tenant/v1/${tenant_id}`));
};

// Get Tenant List
export const getTenantList = async (page = 1, size = 10, name) => {
  return apiSuccessOutput(
    await api.get('/tenant/v1/paginate', {
      params: { page, size, name: name || undefined },
      showToast: false,
    }),
  );
};

// Get Tenant Detail
export const getDetailTenant = async (tenant_id) => {
  return apiSuccessOutput(await api.get(`/tenant/v1/${tenant_id}`));
};

// Get tenant list without paginate
export const getTenantListWithoutPaginate = async (name) => {
  return apiSuccessOutput(
    await api.get('/tenant/v1', {
      params: {
        name,
      },
      showToast: false,
    }),
  );
};

// Create member Tenant
export const createTenantMember = async (phone_number, role) => {
  return apiSuccessOutput(
    await api.post('/tenant/v1/member', {
      phone_number,
      role,
    }),
  );
};

// Get member Tenant List paginate
export const getMemberList = async (page = 1, size = 10) => {
  return apiSuccessOutput(
    await api.get('/tenant/v1/member/paginate', {
      params: { page, size },
      showToast: false,
    }),
  );
};

// Search member Tenant List
export const searchMemberList = async ({
  phone_number,
  first_name,
  last_name,
  role,
  page = 1,
  size = 10,
}) => {
  return apiSuccessOutput(
    await api.get('/tenant/v1/member/search', {
      params: {
        phone_number,
        first_name,
        last_name,
        role,
        page,
        size,
      },
      showToast: false,
    }),
  );
};

// Delete member Tenant
export const deleteTenantMember = async (member_id) => {
  return apiSuccessOutput(await api.delete(`/tenant/v1/member/${member_id}`));
};

// Update member Tenant
export const updateTenantMember = async (member_id, role) => {
  return apiSuccessOutput(
    await api.put(`/tenant/v1/member/${member_id}`, { role }),
  );
};
